export const customerService = {
  email: {
    DustinSweden: 'kundservice@dustin.se',
    DustinHomeSweden: 'kundservice@dustinhome.se',
    DustinFinland: 'asiakaspalvelu@dustin.fi',
    DustinHomeFinland: 'asiakaspalvelu@dustinhome.fi',
    DustinDenmark: 'service@dustin.dk',
    DustinHomeDenmark: 'kundeservice@dustinhome.dk',
    DustinNetherlands: 'klantenservice@dustin.nl',
    DustinHomeNetherlands: 'klantenservice@dustinhome.nl',
    DustinNorway: 'kundeservice@dustin.no',
    DustinHomeNorway: 'kundeservice@dustinhome.no',
    DustinBelgium: 'klantenservice@dustinhome.nl' // TODO: ft-dustin-be
  }
}
